import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mediclaiminformation',
  templateUrl: './mediclaiminformation.component.html',
  styleUrls: ['./mediclaiminformation.component.scss']
})
export class MediclaiminformationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
